import React, {  Component } from 'react';
import { connect } from 'react-redux';

class NotificationUpdateConfirmationOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            isPunchOutAccess: props.isPunchOutAccess
        }
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    // closeDialog(event) {
    //     event.preventDefault();
    //     this.setState({
    //         showDialog: false
    //     });
	// 	this.props.handleDialog('NotificationUpdateConfirmationOverlayDialog');
    // }
	handleOk(event) {
		event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleLastLoginDateUpdateNotifications && this.props.handleLastLoginDateUpdateNotifications();
	}
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog && !this.state.isPunchOutAccess?"visible":"hide")} id="confirmReleaseYesNoOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <h2 className="title">Notifications</h2>
                    <p className="red">Please update your notification preferences under my profile. You will not receive order notifications for this account until you select the notifications you would like to receive.</p>
					<p className="red bold">Make sure to set up notifications for all of your accounts!</p>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.handleOk.bind(this)}>Ok</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

NotificationUpdateConfirmationOverlayDialog = connect(mapStateToProps)(NotificationUpdateConfirmationOverlayDialog);
export default NotificationUpdateConfirmationOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/notificationUpdateConfirmationOverlayDialog.js